import axios from "axios";

// If REACT_APP_BACKEND_URL is unset at build time, `${undefined}` would bake the
// literal string "undefined/api" into the bundle and every request would hit the
// static host (returning index.html). Fall back to a same-origin "/api" instead,
// which works behind a reverse proxy and never produces an "undefined" URL.
const RAW = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = RAW && RAW !== "undefined" ? RAW.replace(/\/$/, "") : "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Guard against the classic SPA-fallback failure: a misrouted /api request that
// returns index.html (an HTML string) with a 200. Without this, pages that call
// r.data.map/.filter/.reduce crash the whole render. Detect an HTML body where
// JSON was expected and reject so callers hit their .catch instead.
api.interceptors.response.use(
  (res) => {
    const ct = String(res.headers?.["content-type"] || "");
    if (typeof res.data === "string" && (ct.includes("text/html") || res.data.trimStart().startsWith("<"))) {
      const err = new Error("API returned HTML instead of JSON — check REACT_APP_BACKEND_URL / backend routing.");
      err.isApiMisroute = true;
      err.config = res.config;
      return Promise.reject(err);
    }
    return res;
  },
  (err) => Promise.reject(err),
);

// Coerce any API payload to an array so list pages never crash on r.data.map/
// .filter/.reduce when a response is null, an object, or an error envelope.
export const asArray = (v) => (Array.isArray(v) ? v : []);

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
